export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-Latin1-bb730844c9185c864437d61d7e302162.woff2";